import { Redirect, Route, RouteProps } from 'react-router-dom';

import { getAppRoutes } from './App.constants';
import PrivateApp, { PrivateAppPropsBase } from './PrivateApp';
import Permission, { PermissionProps } from 'Components/Permission/Permission';
import TenantProvider from 'Pages/TenantProvider';

type PrivateRouteProps = RouteProps &
	PrivateAppPropsBase & {
		// eslint-disable-next-line
		component: any;
		showHeader?: boolean,
		permission?: Omit<PermissionProps, 'children'>;
	};

function PrivateRoute({
	component: Component,
	permission,
	showHeader = false,
	includeLayout,
	...routeProps
}: PrivateRouteProps) {
	return (
		<PrivateApp includeLayout={includeLayout}>
			<TenantProvider showHeader={showHeader}>
				<Route
					{...routeProps}
					render={(props) => {
						const children = <Component {...props} />;
						return permission ? (
							<Permission {...(permission as PermissionProps)}>
								{({ permitted }) => {
									return permitted ? (
										children
									) : (
										<Redirect
											to={getAppRoutes().ERROR_PERMISSION}
										/>
									);
								}}
							</Permission>
						) : (
							children
						);
					}}
				/>
			</TenantProvider>
		</PrivateApp>
	);
}

export default PrivateRoute;